<div class="content-box">
  <input #expando type="checkbox" [id]="inputId" (click)="cdr.detectChanges()" />
  <div class="content" #para [ngClass]="{ truncated: isTruncated(para, expando) }">{{ content }}</div>
  <div class="label-container">
    <label [for]="inputId" role="button">{{ expando.checked ? 'less' : 'more' }}</label>
    <ion-icon name="{{ expando.checked ? 'caret-up-outline' : 'caret-down-outline' }}"></ion-icon>
  </div>
</div>
